export const getDomainOrigin = () => {
  try {
    if (window !== undefined) {
      if (window?.location?.hostname === 'localhost') {
        return 'http://localhost:9000';
      }
      return window?.location?.origin;
    }
    return 'https://www.acko.com';
  } catch (e) {
    console.error('domain error ', e);
    return 'https://www.acko.com';
  }
};

export const getServerHostDomain = (host?: string) => {
  try {
    if (host?.includes('localhost')) {
      return 'http://localhost:9000';
    }
    if (
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' ||
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'master'
    ) {
      return 'https://www.ackodev.com';
    }
    return 'https://www.acko.com';
  } catch {
    return 'https://www.acko.com';
  }
};

export function getHeaders() {
  return {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  };
}
